module.exports = "/_next/static/images/c636e8ea78aa691d4888b5be1c8ef94e-belinda-hero-desktop.jpg";